(() => {
  const articles = document.querySelectorAll('[data-seo-article]');

  articles.forEach((article) => {
    const content = article.querySelector('[data-seo-content]');
    const toc = article.querySelector('[data-seo-toc]');
    const tocList = article.querySelector('[data-seo-toc-list]');

    if (!content || !toc || !tocList) return;

    const headings = Array.from(content.querySelectorAll('h2'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }

    const usedIds = new Set();
    const fragment = document.createDocumentFragment();

    headings.forEach((heading, index) => {
      let id = heading.id || heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

      if (!id) id = `section-${index + 1}`;
      let uniqueId = id;
      let suffix = 2;

      while (usedIds.has(uniqueId) || document.getElementById(uniqueId)) {
        uniqueId = `${id}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(uniqueId);
      heading.id = uniqueId;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${uniqueId}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      fragment.appendChild(item);
    });

    tocList.replaceChildren(fragment);
    toc.hidden = false;
  });
})();
